/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const DocumentManagement = lazyLoad(
  () => import('./index'),
  module => {
    return module.DocumentManagement;
  },
);
